import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { ErgFeedbackPayload, ErgFeedbackResponse } from './erg-feedback.model';

@Injectable({
  providedIn: 'root'
})
export class ErgFeedbackService {

  constructor(
    private readonly http: HttpClient,
    private readonly bpgCommonService: BpgCommonService
  ) { }

  private baseUrl(): string {
    return localStorage.getItem('userManagementUrl') || ConstantValues.userManagementApiUrl.userManagementUrl || '';
  }

  saveFeedback(payload: ErgFeedbackPayload): Observable<any> {
    return this.http.post(
      this.baseUrl() + ConstantValues.userManagementApiUrl.appFeedbackSave,
      payload,
      this.bpgCommonService.tokenizedHeader()
    );
  }

  getFeedback(): Observable<ErgFeedbackResponse[]> {
    return this.http.get<ErgFeedbackResponse[]>(
      this.baseUrl() + ConstantValues.userManagementApiUrl.appFeedbackList,
      this.bpgCommonService.tokenizedHeader() as { headers?: HttpHeaders }
    );
  }
}
